import WhatWeDo from './WhatWeDo';

export default WhatWeDo;
